import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';
import errorBoundary from '@ifeng/errorBoundary';
import NewsTitle from '../../../components/newsTitle';
import NewsList from '../../../components/newsList';

class RightNewsBox extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const {
            content: { historyTitle, historyList, historyListAd },
        } = this.props;

        return (
            <div className={styles.right_box}>
                <Chip id="230182" type="struct" title="历史标题" groupName="历史" content={historyTitle}>
                    <NewsTitle size="short" />
                </Chip>
                <Chip
                    id="195855"
                    type="recommend"
                    title="历史列表"
                    groupName="历史"
                    content={historyList}
                    translate="handleNewsData">
                    <NewsList hasTitle size="short" ad={historyListAd} />
                </Chip>
            </div>
        );
    }
}

export default errorBoundary(RightNewsBox);
